import apiClient from "./axios"

export const getAccountCustomerPayments = async (params = {}) => {
  const { data } = await apiClient.get("/account-customer-payments", { params })
  return data
}

export const getAccountCustomerPayment = async id => {
  const { data } = await apiClient.get(`/account-customer-payments/${id}`)
  return data
}

export const createAccountCustomerPayment = async payload => {
  const { data } = await apiClient.post("/account-customer-payments", payload)
  return data
}

export const updateAccountCustomerPayment = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/account-customer-payments/${id}`, payload)
  return data
}

export const deleteAccountCustomerPayment = async id => {
  const { data } = await apiClient.delete(`/account-customer-payments/${id}`)
  return data
}
